import { useState, useMemo, useEffect } from "react";

import {
  Box,
  Grid,
  Text,
  HStack,
  VStack,
  Heading,
  // CircularProgress,
  Container,
  Breadcrumb,
  BreadcrumbItem,
  FormControl,
  FormHelperText,
  useToast,
  useDisclosure,
} from "@chakra-ui/react";

import { useParams, useHistory } from "react-router-dom";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import Input from "components/Input/Input";
import Select from "components/Select/Select";
import Button from "components/Button/Button";
import SuccessModal from "components/Modals/Success";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import constants from "config/constant";
import toCoinLocale from "util/toCoinLocale";
import toPrecision from "util/toPrecision";

import { usePaybackLoanMutation } from "services/walletApi";

import useWallet from "hooks/useWalletBalance";

export default function PaybackLoan(props) {
  const currentPage = "Home";

  const { id } = useParams();
  const toast = useToast();
  const history = useHistory();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [state, setState] = useState();

  const loan = useMemo(() => props?.location?.state, [props]);

  console.log("LOAN", loan);

  const { getBalance } = useWallet();

  // const { data } = useGetLoanByIdQuery(id);

  const handleState = (newState) => setState({ ...state, ...newState });
  const [payback, { data: paybackData, isSuccess, isError, error, isLoading }] =
    usePaybackLoanMutation();

  // console.log("DATA", data);

  const handleSubmit = () => {
    payback({ id, wallet: state?.wallet });
  };

  const handleClose = () => {
    onClose();
    history.replace("/dashboard/bcpl");
  };

  const isInsufficientBalance = useMemo(
    () => getBalance(state?.wallet) < (+loan?.currencyValue ?? 0),
    [loan, state?.wallet, getBalance]
  );

  const isDisabled = useMemo(
    () => !state?.wallet || isLoading || isInsufficientBalance,
    [state, isLoading, isInsufficientBalance]
  );

  const getError = (error) => {
    function isObj(obj) {
      var type = typeof obj;
      return type === "function" || (type === "object" && !!obj);
    }
    const value = isObj(error) ? Object.values(error)[0] : error;
    // console.log("ERROR VALUE", value);
    return value ?? "An unexpected error occurred";
  };

  useEffect(() => {
    if (isSuccess && paybackData) {
      onOpen();
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, isError, paybackData, error, toast, onOpen]);

  console.log("PAYBACK DATA", paybackData);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="bcpl">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container maxW="container.xl">
            <Box px={["24px", "0", "0"]}>
              <Heading fontSize="3xl">Payback Loan</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/home">Home</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem>
                  <BreadcrumbLink to="/dashboard/bcpl">BCPL</BreadcrumbLink>
                </BreadcrumbItem>

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Payback Loan
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Grid
              templateColumns={["1fr", "1fr", "repeat(2, 1fr)"]}
              mt="32px"
              gap="20px"
            >
              <Box
                bg="white"
                // border="1px solid #8688942f"
                // minH="681px"
                //   w="calc(100% - 25vw)"
                // w="fit-content"
                borderRadius="16px"
                shadow="0px 8px 24px rgba(154, 170, 207, 0.15)"
                p="48px"
              >
                <VStack>
                  <FormControl>
                    <Select label="Payment Method">
                      <option>Bitmama Wallet</option>
                    </Select>
                  </FormControl>

                  <FormControl>
                    <Select
                      label="Coin Type"
                      placeholder="Select coin type"
                      value={state?.wallet ?? ""}
                      onChange={(e) => handleState({ wallet: e.target.value })}
                    >
                      {/* <option>BTC</option>
                      <option>ETH</option>
                      <option>CELO</option> */}
                      {constants.stableCoins.map((coin) => (
                        <option value={coin}>{toCoinLocale(coin)}</option>
                      ))}
                    </Select>
                    {state?.wallet && !isInsufficientBalance && (
                      <FormHelperText>
                        <HStack>
                          <Text>Available balance:</Text>
                          <Text>
                            {toPrecision(
                              getBalance(state?.wallet),
                              state?.wallet
                            )}
                          </Text>
                        </HStack>
                      </FormHelperText>
                    )}
                    {state?.wallet && isInsufficientBalance && (
                      <FormHelperText color="red.400">
                        <HStack>
                          <Text>Insufficient balance</Text>
                          <Text>
                            {toPrecision(
                              getBalance(state?.wallet),
                              state?.wallet
                            )}
                          </Text>
                        </HStack>
                      </FormHelperText>
                    )}
                  </FormControl>

                  <FormControl mt="20px !important">
                    <Input
                      label="Payback amount"
                      defaultValue={toPrecision(
                        +loan?.currencyValue * 1.15,
                        loan?.coin,
                        false
                      )}
                      isDisabled
                      startAdornment={"$"}
                    />
                  </FormControl>

                  <Button
                    minW="100%"
                    minH="64px"
                    mt="40px !important"
                    onClick={handleSubmit}
                    disabled={isDisabled}
                    isLoading={isLoading}
                  >
                    Submit
                  </Button>
                </VStack>
              </Box>
            </Grid>
          </Container>
        </Box>
      </Box>

      <SuccessModal
        title="Success"
        message={"Loan payback processed successfully"}
        isOpen={isOpen}
        onClose={handleClose}
      />
    </Box>
  );
}
